<template>
<div>
        <m-confirm-list ref="confirm"></m-confirm-list>
        <m-booking-add-form :form="formBooking" :booking="selectedItem" :dialog="dialog_booking" @save="onSaveBooking" @close="onCloseBooking" ></m-booking-add-form>
        <m-destination-form :form="formDestination" :destination="selectedItem" :dialog="dialog_destination" @save="onSaveDestination" @close="closeDestination"></m-destination-form>
        <m-client-form :form="formClient" :user="selectedItem" :dialog="dialog_client" @save="onSaveClient" @close="onClose"></m-client-form>
        <m-route-map ref="routeMap" @close="onClose"></m-route-map>
        <div class="booqit">
            <v-toolbar flat color="white">
              <v-toolbar-title>Booqit</v-toolbar-title>
              <v-divider
                class="mx-2"
                inset
                vertical
              ></v-divider>
              <v-btn color="primary" dark class="ma-1" @click="inbox"> <v-icon small class="mr-1">refresh </v-icon>inbox</v-btn>
              <v-btn color="primary" dark class="ma-1" @click="trips"><v-icon small class="mr-1">refresh </v-icon>transports </v-btn>
              <v-btn color="primary" dark class="ma-1" @click="series"><v-icon small class="mr-1">refresh </v-icon>Series </v-btn>
              <v-spacer></v-spacer>

              <v-text-field
                class="mr-5"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                v-model="search_booqits"
              ></v-text-field>

              <v-dialog
                  v-model="dialog_loader"
                  persistent
                  width="300"
                >
                  <v-card
                    color="primary"
                    dark
                  >
                    <v-card-text class="pt-3">
                      Please stand by
                      <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                      ></v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                      <v-btn v-if="booqit.length > 0" icon class="mx-0 hidden-sm-and-down" @click="checkBookings">
                        <v-icon color="primary">check</v-icon>
                      </v-btn>
                      <v-btn icon class="mx-0 hidden-sm-and-down" @click="clear">
                        <v-icon color="primary">delete</v-icon>
                      </v-btn>
            </v-toolbar>
            <v-data-table
              :headers="headers"
              :items="filteredBooqit"
              :options.sync="options"
              :sort-by="['dateTime']"
              :sort-desc="[true]"
              :key="componentKey"
              item-key="transportId"
              :footer-props="{
                'items-per-page-options': [30, 40, {text:'All', value:-1}]
              }"

              class="elevation-1"
            >
              <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="item in items" :key="item.name" :class="{'isDone':item[0].isDone}">
                  <td @click="expandme(item)">
                    <div>
                    <v-icon v-if="item[1]"
                      small
                    >
                      all_inclusive
                    </v-icon>
                    </div>
                  </td>
                <td class="text-xs-left"><div>{{ item[0].dateTime | datetime}}</div></td>
                <td class="text-xs-left"><div>{{ item[0].passenger }}</div></td>
                <td class="text-xs-left"><div>{{ item[0].reason }}</div></td>
                <td class="text-xs-left"><div>{{ item[0].pickup }}</div></td>
                <td class="text-xs-left"><div>{{ item[0].dropOff }}</div></td>
                <td class="text-xs-left no-break"><div>{{ item[0].price | currency}}</div></td>
                <td class="text-xs-left no-break"><div>{{ item[0].total | currency}}</div></td>
                <td class="text-xs-right">
                  <div>
                  <v-icon
                    small
                    class="mr-2 "
                    @click="showRoute(item[0])"
                  >
                    timeline
                  </v-icon>
                  <v-icon v-if="item[0].client.id && item[0].destination.id"
                  class="mr-2 notchecked"
                    small
                    @click="bookItem(item)"
                  >
                    directions_car
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2 notchecked"
                    v-if= "item[0].passenger && !item[0].client.id"
                    :class="{'notchecked': !item[0].client}"
                    @click="checkOnES(item[0], 'client')"
                  >
                    person
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2 notchecked"
                    v-if= "!item[0].destination.id"
                    :class="{'notchecked': !item[0].destination}"
                    @click="checkOnES(item[0], 'destination')"
                  >
                    domain
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2"
                    @click="viewItem(item[0])"
                  >
                    visibility
                  </v-icon>
                  </div>
                </td>
                </tr>
              </tbody>
            </template>
              <template v-slot:no-data>
                no data
              </template>
            </v-data-table>
          </div>


      </div>

</template>
<script>
/*
 {label: "forfait10km", km: 10, costTotal: 16}
 {label: "from11to30", km: 20, costUnit: 1.78, costTotal: 35.6}
 {label: "above30", km: 64, costUnit: 1.2, costTotal: 76.8}
*/
  import BooqitMixin from '@/mixins/booqit'

  export default {
    name: 'booqitComponent',
    mixins: [BooqitMixin],
    data () {
      return {
        headers: [
          { text: '', value: 'back' },
          { text: 'dateTime', value: 'dateTime' },
          { text: 'passenger', value: 'passenger' },
          { text: 'reason', value: 'reason' },
          { text: 'pickup', value: 'pickup' },
          { text: 'dropOff', value: 'dropOff' },
          { text: 'price', value: 'total' },
          { text: 'total', value: 'total' },
          { text: 'Actions', value: 'name', sortable: false }
        ]
      }
    }
  }
  </script>
<style lang="scss">
.booqit{
  .executed {
    background:rgba(32, 151, 2, 0.1) !important;
  }
  .toConfirmAssignment, .toConfirmDelete {
    background:rgba(248, 1, 1, 0.1) !important;
  }
  .no-break {
    white-space: nowrap;
  }
  .notchecked {
    color: red;
  }
  .isDone {
    color: green;
  }
  table {
    border-collapse: collapse;
  }
  tr.not-expanded td {
    height: inherit;
  }
  tr.not-expanded td div {
    max-height: 0;
    overflow: hidden;
  }
  tr.expanded {
    box-shadow:inset 0px 0px 0px 5px rgb(240, 238, 238);
    td div {
      padding: 5px;
      max-height: 100px;
      overflow: hidden;
    }
  }

  .theme--light.v-table tbody tr:hover {
    background: inherit;
  }
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
      padding: 0 12px;
      max-width: 200px;
  }
}
</style>
